export default "__VITE_ASSET__B6V44wS$__"